import {Badge} from '@mantine/core'

import {lifecycleStatusColor, lifecycleStatusLabel} from 'src/theme/semantic-colors'

import type {JobLifecycleStatus} from './types'

type JobStatusBadgeProps = {
    status: JobLifecycleStatus
    variant?: 'filled' | 'light'
}

/** @deprecated Prefer `lifecycleStatusLabel` from semantic-colors. */
export function jobStatusLabel(status: JobLifecycleStatus): string {
    return lifecycleStatusLabel(status)
}

export function jobStatusColor(status: JobLifecycleStatus): string {
    return lifecycleStatusColor(status)
}

/**
 * Shared lifecycle badge for jobs and projects.
 * Default `light` matches quotes, invoices, and other status badges.
 */
export function JobStatusBadge({status, variant = 'light'}: JobStatusBadgeProps) {
    return (
        <Badge color={jobStatusColor(status)} variant={variant} size="md" radius="xl">
            {lifecycleStatusLabel(status)}
        </Badge>
    )
}
